import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import {
  GroupComponent,
  InputComponent,
  SelectOption,
  TypeaheadComponent,
  TypeaheadInputDirective,
} from '@recruitee/user-interface';
import { includesWithTrim } from '@recruitee/utils';

import { DynamicTypeaheadInputConfig } from '../../../types';
import { DynamicFormInput } from '../dynamic-form-input/dynamic-form-input';

export class TypeaheadInput extends DynamicFormInput<DynamicTypeaheadInputConfig> {}

@Component({
  selector: 'rti-dynamic-typeahead-input',
  templateUrl: './dynamic-typeahead-input.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    GroupComponent,
    InputComponent,
    ReactiveFormsModule,
    TypeaheadComponent,
    TypeaheadInputDirective,
  ],
})
export class DynamicTypeaheadInputComponent {
  @Input() public input: TypeaheadInput;

  public suggestions: Array<SelectOption<string>> = [];

  public onChange(query: string): void {
    const searchValue = query.toLowerCase();

    this.suggestions = this.input.config.options
      .filter(option => includesWithTrim(option, searchValue, { trim: false }))
      .map(option => ({ label: option, value: option }));
  }
}
